import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, TimePicker, DatePicker, Radio } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import ImageUpload from '../../utils/ImageUpload';
import { addModules, editModules, getModules } from '../../feature/modules/moduleSlice';
import { toBase64 } from '../../utils/ImageConvert';
import { getEnquiryStatus, requestStatusData } from '../../constant/Constatnt';
import { editEnquiry, getEnquiry } from '../../feature/enquiry/enquirySlice';



function EditEnquiry({ editData }) {
    const { _id, enquiryStatus, closedRemarks } = editData
    const { actionLoader } = useSelector((state) => state.enquiries);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()


    const onFinish = async (values) => {
        const resultAction = await dispatch(editEnquiry({ ...values, daycareEnqueryId: _id }));
        if (editEnquiry.fulfilled.match(resultAction)) {
            await dispatch(getEnquiry({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("edit modules");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                name="newStatus"
                label="Status "
                rules={[{ required: true, message: 'Please enter  mark' }]}
            >
                <Radio.Group options={requestStatusData} defaultValue={enquiryStatus} />
            </Form.Item>
            <Form.Item
                name="remarks"
                label="Remark "
            // rules={[{ required: true, message: 'Please enter  remark  ' }]}
            >
                <Input.TextArea placeholder='Write here...' />
            </Form.Item>

            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const editProps = {
        open,
        setOpen,
        title: 'Action on Enquiry ',
        action: 'Edit',
        content: AddForm,
        btnType: "link",
        status: enquiryStatus,
        remark: closedRemarks
    };

    return (
        <section>
            <AddDrawer {...editProps} />
        </section>
    );
}


export default EditEnquiry